<template lang="pug">
component(
  :is="$_tag",
  tabindex="0"
  :loading="isSpinner",
  :disabled="isDisabled",
  class="BaseFormButton base-form-button"
  v-bind="$attrs",
  large
  v-on="$listeners",
)
  slot
</template>

<script>
import BaseButton from 'Components/Base/BaseButton';

export default {
  name: 'BaseFormButton',
  components: {
    BaseButton,
  },
  inject: {
    formLoading: {
      from: 'formLoading',
      default: () => {},
    },
  },
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    disabled: Boolean,
  },
  computed: {
    $_tag() {
      if (this.tag === 'button') return BaseButton;
      return this.tag;
    },
    isLoadingSend() {
      return this.formLoading && this.formLoading.send;
    },
    isLoadingAll() {
      return this.formLoading && this.formLoading.all;
    },
    isSpinner() {
      return this.isLoadingSend && this.isSubmit;
    },
    isDisabled() {
      return this.disabled || (this.isLoadingAll && !this.isSpinner);
    },
    isSubmit() {
      return this.$attrs.type === 'submit';
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
